
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lending-partners",
      function () {
        return require("private-next-pages/lending-partners.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lending-partners"])
      });
    }
  